<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

import { useLobbyGames } from '~/composables/lobby-games/use-lobby-games'
import { GAMES_HOT_LIMIT } from '~/constants'

const DirectGames = defineAsyncComponent(
  async () => await import('~/components/mobile/pages/lobby-games/direct-games.vue')
)

const GAMES_HOT_GROUPS_PARAM = 'hot'

const { totalPost, fetchGames } = useLobbyGames({ instantFetch: false })

const initialPayload = {
  cats: '',
  groups: GAMES_HOT_GROUPS_PARAM,
  limit: GAMES_HOT_LIMIT
}
const { data } = await useAsyncData('games-home-mb', async () => {
  const result = await fetchGames(initialPayload)
  return result
})

const lobbyGames = computed(() => data.value?.games || [])
</script>

<template>
  <section class="games-hot-section">
    <h2 class="section-title">GAMES HOT</h2>
    <div class="section-wrapper">
      <DirectGames :lobbyGames="lobbyGames" :totalPost="totalPost" hideLoadMoreButton hideGameName />
    </div>
  </section>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/pages/home/game-hot-section.scss';
</style>
